import classNames from 'classnames'
import { FC } from 'react'
import PerText from '../../../components/custom_components/Text'
import { AppraisalMonitoringTableStatusFilter, appraisalMonitoringStatusAccent } from '../utils/appraisalMeetingStatusDashboardUtil'
import './DashboardAppraisalMonitoringHistogramBar.less'

const MONITORING_HISTOGRAM_BAR_TRACK_HEIGHT_PX = 168
const MONITORING_HISTOGRAM_BAR_PILL_WIDTH_PX = 36
const MONITORING_HISTOGRAM_BAR_PILL_DIAMETER_PX = MONITORING_HISTOGRAM_BAR_PILL_WIDTH_PX
const BAR_HEIGHT_TRACK_RANGE_PX = MONITORING_HISTOGRAM_BAR_TRACK_HEIGHT_PX - MONITORING_HISTOGRAM_BAR_PILL_DIAMETER_PX

export type MonitoringHistogramBarColumn = {
  status: AppraisalMonitoringTableStatusFilter
  count: number
  barWidthPx: number
  barHeightPx: number
}

/** Fixed width; height only scales with count / maxCount. */
export const getMonitoringHistogramBarLayout = (
  count: number,
  maxCount: number,
): {
  barWidthPx: number
  barHeightPx: number
} => {
  const w = MONITORING_HISTOGRAM_BAR_PILL_WIDTH_PX
  const d = MONITORING_HISTOGRAM_BAR_PILL_DIAMETER_PX
  if (count === 0) {
    return { barWidthPx: w, barHeightPx: d }
  }
  const ratio = count / maxCount
  return {
    barWidthPx: w,
    barHeightPx: d + ratio * BAR_HEIGHT_TRACK_RANGE_PX,
  }
}

export type MonitoringHistogramBarProps = {
  col: MonitoringHistogramBarColumn
}

export const MonitoringHistogramBar: FC<MonitoringHistogramBarProps> = ({ col }) => {
  const accent = appraisalMonitoringStatusAccent(col.status)
  return (
    <div
      className="dashboard-appraisal-monitoring-histogram-bar"
      style={{
        width: '100%',
        height: MONITORING_HISTOGRAM_BAR_TRACK_HEIGHT_PX,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        boxSizing: 'border-box',
      }}
    >
      <div
        className={classNames('dashboard-appraisal-monitoring-histogram-bar__pill', {
          'dashboard-appraisal-monitoring-histogram-bar__pill--attention': accent === 'attention',
          'dashboard-appraisal-monitoring-histogram-bar__pill--attention-critical': accent === 'attention-critical',
          'dashboard-appraisal-monitoring-histogram-bar__pill--closed': accent === 'closed',
        })}
        style={{
          width: col.barWidthPx,
          height: col.barHeightPx,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
          borderRadius: col.barWidthPx / 2,
          paddingBottom: col.count === 0 ? undefined : col.barHeightPx - col.barWidthPx / 2 - 12,
        }}
      >
        <PerText fontSize="s" fontWeight="bold" color="white" align="center">
          {col.count}
        </PerText>
      </div>
    </div>
  )
}
